export const SHAPE_LINEAR = 'linear';

export const STYLE_CONFIG = {
    gradient: {
        stopColor: '#4BE1A0',
        railColor: '#EEEDF2',
    },
    dark: {
        stopColor: '#000000',
        railColor: 'rgba(40,44,53,0.2)',
    },
    light: {
        stopColor: '#ffffff',
        railColor: 'rgba(40,44,53,0.5)',
    },
};
